// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.filters-list[data-v-1704a4c4] {\n  display: flex;\n  flex-wrap: wrap;\n}\n", ""]);
// Exports
module.exports = exports;
